import { render, staticRenderFns } from "./PayableTariff.vue?vue&type=template&id=5ec2c742&scoped=true"
import script from "./PayableTariff.vue?vue&type=script&lang=js"
export * from "./PayableTariff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec2c742",
  null
  
)

export default component.exports